<template>
  <div class="common-layout">
    <el-container style="min-height: 100vh">
      <el-header style="padding: 0">
        <el-affix :offset="0">
          <HeaderModule />
        </el-affix>
      </el-header>
      <el-main
        style="
          padding: 0;
          margin-top: -60px;
          background-color: rgba(245, 247, 250, 0.6);
        "
      >
        <div
          class="carousel-container"
          style="background-color: #f0f0f0; height: 100vh;text-align: center;"
        >
          <!-- 添加一个容器用于放置文字，使用绝对定位使其位于上层 -->
          <!-- 添加一个容器用于放置文字，使用绝对定位和z-index确保它在轮播组件上层 -->
          <div
            class="carousel-header"
            style="
              position: absolute;
              width: 100%;
              top: 50%;
              transform: translateY(-50%);
              z-index: 10;
              color: #ffffff;
              transform: translateY(-50%);
            "
          >
            <el-avatar
              :size="200"
              :src="require('../../assets/img/avatar1.jpg')"
            />
            <br />
            <h1 class="carousel-title">晨曦&暮雪&nbsp;&nbsp;·&nbsp;&nbsp;ZG-Blog个人空间</h1>
            <br />
            <el-card class="title-card">
              <el-row>
                <el-col :span="4" class="left-button-col shake-icon" @click="prevCarousel">
                  <el-icon :size="30" color="#409efc" style="cursor: pointer"
                    ><DArrowLeft
                  /></el-icon>
                </el-col>
                <el-col :span="16" class="center-content">
                  <p class="title-p">“{{verse}}”</p>
                  <p class="title-p title-right">——{{author}}</p>
                </el-col>
                <el-col :span="4" class="right-button-col shake-right-icon" @click="nextCarousel">
                  <el-icon :size="30" color="#409efc" style="cursor: pointer"
                    ><DArrowRight
                  /></el-icon>
                </el-col>
              </el-row>
            </el-card>
            <div class="bouncing-icon-container" @click="scrollToBottom">
              <el-icon :size="40">
                <ArrowDownBold />
              </el-icon>
            </div>
          </div>
          <el-carousel
            indicator-position="none"
            class="full-carousel"
            style="position: relative; z-index: 1"
            :interval="20000"
            ref="carouselRef"
          >
            <el-carousel-item v-for="item in imageUrls" :key="item">
              <!-- <h3 text="2xl" justify="center">{{ item }}</h3> -->
              <img
                :src="item.url"
                alt=""
                style="height: 100%; width: 100%; display: block"
              />
            </el-carousel-item>
          </el-carousel>
        </div>
        <el-carousel
          style="
            margin: 2% 30% 1% 30%;
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.8);
          "
          height="200px"
          direction="vertical"
          :autoplay="true"
          :interval="5000"
        >
          <el-carousel-item
            v-for="(item) in announCements"
            :key="item.id"
            style="
              background-color: rgba(0, 0, 0, 0.3);
              backdrop-filter: blur(8px) saturate(180%);
              text-align: left;
            "
            @click="announCement(item)"
          >
            <el-row
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                height: 30%;
                margin: 0 5% ;
              "
            >
              <el-col :span="14"
                ><el-icon color="#337ecc" size="20"><ChatLineSquare /></el-icon
                ><el-text style="color: #ffffff; font-size: 20px">
                  {{ item.title }}
                </el-text>
              </el-col>
              <el-col :span="4"></el-col>
              <el-col :span="6">
                <el-tag
                  type="info"
                  effect="dark"
                  style="
                    font-size: 15px;
                    border: 1px solid #337ecc;
                    color: #337ecc;
                    background-color: transparent;
                  "
                >
                  {{ item.typeText }}
                </el-tag>
              </el-col>
            </el-row>
            <el-row
              style="
                display: flex;
                justify-content: center;
                height: 70%;
                margin: 0 5% ;
              "
            >
              <el-col :span="23">
                <el-text
                  line-clamp="3"
                  style="
                    text-align: left;
                    font-size: 20px;
                    text-indent: 2em;
                    color: #ffffff;
                  "
                >
                  {{ item.content }}
                </el-text>
              </el-col>
              <el-col :span="1"></el-col>
            </el-row>
          </el-carousel-item>
        </el-carousel>
        <div style="margin: 30px 10px 30px 10px;text-align: center;">
          <el-space
            direction="vertical"
            :fill-ratio="fillRatio"
            style="width: 50%"
            fill
            wrap
            :size="size"
          >
            <el-card
              style="
                width: 50%;
                height: 350px;
                margin: 0 auto;
                border: 0;
                border-radius: 30px;
                /* box-shadow: 8px 8px 20px rgba(64, 158, 255, 0.8); */
                background-color: rgba(255, 255, 255, 0.2);
              "
              class="hover-effect"
              v-for="(item, index) in blogData"
              :key="index"
              :style="getBoxShadow(index)"
            >
              <el-row v-if="index % 2 === 0">
                <el-col :span="12" style="height: 100%; width: 100%;">
                  <div style="height: 100%">
                    <el-image :src="item.picture" fit="fill" />
                  </div>
                </el-col>
                <el-col :span="12" style="height: 100%; width: 100%;" @click="openInfo(item.id)">
                  <el-row>
                    <el-col :span="24" style="height: 15%">
                      <el-row>
                        <el-col :span="2"></el-col>
                        <el-col :span="4"></el-col>
                        <el-col :span="4"></el-col>
                        <el-col :span="14">
                          <el-tag
                            type="info"
                            effect="dark"
                            style="
                              margin-top: 30px;
                              font-size: 20px;
                              color: #337ecc;
                              background-color: transparent;
                              border: 1px solid #337ecc;
                            "
                          >
                            发表于 {{ item.creationTimeStr }}
                          </el-tag>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="24" style="height: 15%">
                      <h1 class="pointer">{{ item.title }}</h1>
                    </el-col>
                    <el-col :span="24" style="height: 10%">
                      <el-row>
                        <el-col :span="2"></el-col>
                        <el-col :span="6">
                          <el-text size="large">
                            <el-icon>
                              <View />
                            </el-icon>
                            阅读量 {{ item.readingQuantity }}
                          </el-text>
                        </el-col>
                        <el-col :span="1"></el-col>
                        <el-col :span="6">
                          <el-text size="large">
                            <el-icon>
                              <ChatDotSquare />
                            </el-icon>
                            0 条评论
                          </el-text>
                        </el-col>
                        <el-col :span="1"></el-col>
                        <el-col :span="6">
                          <el-text size="large">
                            <el-icon>
                              <MessageBox />
                            </el-icon>
                            {{ item.mainTagText }}
                          </el-text>
                        </el-col>
                        <el-col :span="2"></el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="24" style="height: 40%">
                      <el-text
                        line-clamp="3"
                        style="font-size: 18px; text-indent: 2em"
                      >
                        {{ item.bodyMd }}
                      </el-text>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>

              <el-row v-else>
                <el-col :span="12" style="height: 100%; width: 100%;" @click="openInfo(item.id)">
                  <el-row>
                    <el-col :span="24" style="height: 15%">
                      <el-row>
                        <el-col :span="14">
                          <el-tag
                            type="info"
                            effect="dark"
                            style="
                              margin-top: 30px;
                              font-size: 20px;
                              color: #337ecc;
                              background-color: transparent;
                              border: 1px solid #337ecc;
                            "
                          >
                            发表于 {{ item.creationTimeStr }}
                          </el-tag>
                        </el-col>
                        <el-col :span="2"></el-col>
                        <el-col :span="4"></el-col>
                        <el-col :span="4"></el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="24" style="height: 15%">
                      <h1 class="pointer">{{ item.title }}</h1>
                    </el-col>
                    <el-col :span="24" style="height: 10%">
                      <el-row>
                        <el-col :span="2"></el-col>
                        <el-col :span="6">
                          <el-text size="large">
                            <el-icon>
                              <View />
                            </el-icon>
                            阅读量 {{ item.readingQuantity }}
                          </el-text>
                        </el-col>
                        <el-col :span="1"></el-col>
                        <el-col :span="6">
                          <el-text size="large">
                            <el-icon>
                              <ChatDotSquare />
                            </el-icon>
                            0 条评论
                          </el-text>
                        </el-col>
                        <el-col :span="1"></el-col>
                        <el-col :span="6">
                          <el-text size="large">
                            <el-icon>
                              <MessageBox />
                            </el-icon>
                            {{ item.mainTagText }}
                          </el-text>
                        </el-col>
                        <el-col :span="2"></el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="24" style="height: 40%">
                      <el-text
                        line-clamp="3"
                        style="font-size: 18px; text-indent: 2em"
                      >
                        {{ item.bodyMd }}
                      </el-text>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="12"  style="height: 100%; width: 100%;">
                  <div style="height: 100%">
                    <el-image :src="item.picture" fit="fill" />
                  </div>
                </el-col>
              </el-row>
            </el-card>
            <el-button
              round
              style="
                height: 60px;
                margin: 0 30% 0 30%;
                color: #ffffff;
                font-size: 30px;
                background-color: transparent;
                border-radius: 30px;
              "
              @click="load"
              :loading="isLoading"
              v-if="blogCount > currentBlogCount"
              ><el-text
                :style="{ display: isHidden ? 'none' : 'block' }"
                style="color: #ffffff; font-size: 20px"
                >查看更多</el-text
              ></el-button
            >
            <el-button
              round
              style="
                height: 60px;
                margin: 0 30% 0 30%;
                color: #ffffff;
                font-size: 30px;
                background-color: transparent;
                border-radius: 30px;
              "
              disabled
              v-else
              ><el-text
                style="color: #ffffff; font-size: 20px"
                >到底啦~</el-text
              ></el-button
            >
          </el-space>
        </div>
      </el-main>
      <el-footer>
        <FooterModule />
      </el-footer>
    </el-container>
  </div>
  <el-dialog
    v-model="centerDialogVisible"
    :title="announCementInfo.title"
    width="60%"
    align-center
    :show-close="showClose"
    destroy-on-close
    @close="handleClose"
  >
    <div style="text-align: center;">
      <el-row>
        <el-col :span="4"></el-col>
        <el-col :span="16">
          <el-text size="large" style="color: #c0c4cc">
            <el-icon color="#C0C4CC">
              <Calendar />
            </el-icon>
            发表于 {{ announCementInfo.releaseTime }}
          </el-text>
          <el-divider direction="vertical" />
          <el-text size="large" style="color: #c0c4cc">
            <el-icon color="#C0C4CC">
              <User />
            </el-icon>
            {{ announCementInfo.creationBy }}
          </el-text>
          <el-divider direction="vertical" />
          <el-text size="large" style="color: #c0c4cc">
            <el-icon color="#C0C4CC">
              <View />
            </el-icon>
            阅读量 {{ announCementInfo.readingQuantity }}
          </el-text>
          <el-divider direction="vertical" />
          <el-tag
            type="info"
            effect="dark"
            style="
              font-size: 15px;
              border: 1px solid #337ecc;
              color: #337ecc;
              background-color: transparent;
            "
          >
            {{ announCementInfo.typeText }}
          </el-tag>
        </el-col>
        <el-col :span="4"></el-col>
      </el-row>
    </div>
    <br/>
    <span
      style="
        display: inline-block;

        font-size: 20px;
        text-indent: 2em;
      "
    >
      {{ announCementInfo.content }}</span
    >
  </el-dialog>
  <BackTop />
  <BackGround style="position: absolute; z-index: -1" />
</template>

<script>
import { onMounted,ref } from "vue";
import { useRouter } from 'vue-router';
import {findHomeVerse,findSysNotice,addReadingQuantity,findHomeImgs,findBlogPagesNum,findBlogPages} from '@/api/api';
export default {
  components: {},
  setup() {
    const router = useRouter();
    const centerDialogVisible = ref(false);
    const fillRatio = ref(100);
    const isLoading = ref(false);
    const isHidden = ref(false);
    const showClose = ref(true);
    const size = ref(50);

    const blogData = ref([]);
    const currentPage = ref(1);
    const blogCount = ref(0);
    const currentBlogCount = ref(0);

    const load = () => {
      isLoading.value = true;
      isHidden.value = true;
      setTimeout(() => {
        findBlogPages({pageNum: currentPage.value})
          .then((response) => {
            console.log(response.data.length);
            blogData.value.push(...response.data);
            currentPage.value += 1;
            currentBlogCount.value = currentBlogCount.value + response.data.length
          })
          .catch(() => {
          });
        isLoading.value = false;
        isHidden.value = false;
      }, 2000);
    };

    const openInfo = (id) => {
      router.push(`/BlogInfo/${id}`)
    };
    const imageUrls = ref([]);
    const getBoxShadow = (index) => ({
      boxShadow:
        index % 2 === 0
          ? "8px 8px 20px rgba(0, 0, 0, 0.8)"
          : "-8px 8px 20px rgba(0, 0, 0, 0.8)",
    });

    const scrollToBottom = () => {
      window.scrollTo({
        top: window.innerHeight - 60,
        behavior: "smooth",
      });
    };

    const carouselRef = ref(null);
    // 定义 prevCarousel 方法来调用 carousel 的 prev 方法
    const prevCarousel = () => {
      if (carouselRef.value && carouselRef.value.prev) {
        carouselRef.value.prev();
        nextVerse();
      }
    };

    // 定义 nextCarousel 方法来调用 carousel 的 next 方法
    const nextCarousel = () => {
      if (carouselRef.value && carouselRef.value.next) {
        carouselRef.value.next();
        nextVerse();
      }
    };

    const handleClose = () => {
      findSysNotice()
        .then((response) => {
          announCements.value = response.data;
        })
        .catch(() => {
        });
    };

    //公告通知模块
    const announCements = ref([]);
    const announCementInfo = ref({});
    const announCement = (item) => {
      centerDialogVisible.value = true;
      announCementInfo.value = {};
      announCementInfo.value = {
        id: item.id,
        releaseTime: item.releaseTime,
        creationBy: item.creationBy,
        readingQuantity: item.readingQuantity,
        title: item.title,
        type: item.type,
        typeText: item.typeText,
        content: item.content,
      };
      addReadingQuantity({ id: item.id})
        .then(() => {
        })
        .catch(() => {
        });
    };

    // 定义首页大幕诗句
    const verses = ref([]);
    const currentVerseIndex = ref(0); // 初始化一个默认值，这里假设为0，但稍后会在数据加载后重新赋值
    let verse = ref(''); // 初始化一个空字符串作为默认值
    let author = ref(''); // 初始化一个空字符串作为默认值

    onMounted(async () => {
      findHomeVerse()
          .then((response) => {
            verses.value = response.data;
                // 数据加载完成后，重新初始化 currentVerseIndex、verse 和 author
            if (verses.value.length > 0) {
            currentVerseIndex.value = Math.floor(Math.random() * verses.value.length);
            verse.value = verses.value[currentVerseIndex.value].verse;
            author.value = verses.value[currentVerseIndex.value].author;
    }
          })
          .catch(() => {
          });

      findSysNotice()
          .then((response) => {
            announCements.value = response.data;
          })
          .catch(() => {
          });
      findHomeImgs()
          .then((response) => {
            imageUrls.value = response.data;
          })
          .catch(() => {
          });
      findBlogPagesNum()
          .then((response) => {
            blogCount.value = response.data;
          })
          .catch(() => {
          });
      findBlogPages({pageNum: currentPage.value})
          .then((response) => {
            blogData.value = response.data;
            currentPage.value += 1;
            currentBlogCount.value = blogData.value.length;
          })
          .catch(() => {
          });
    })
    function nextVerse() {
      currentVerseIndex.value = Math.floor(Math.random() * verses.value.length);
      verse.value = verses.value[currentVerseIndex.value].verse;
      author.value = verses.value[currentVerseIndex.value].author;
    }

    return {
      imageUrls,
      size,
      blogData,
      blogCount,
      currentBlogCount,
      isLoading,
      isHidden,
      fillRatio,
      centerDialogVisible,
      announCements,
      showClose,
      announCementInfo,
      carouselRef,
      verses,
      verse,
      author,
      getBoxShadow,
      load,
      announCement,
      scrollToBottom,
      prevCarousel,
      nextCarousel,
      handleClose,
      openInfo,
    };
  },
};
</script>

<style scoped>
.el-carousel__item h3 {
  display: flex;
  color: #475669;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.full-carousel {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
:deep(.el-carousel__container,
) {
  height: 100%;
}

.el-row,
.el-image {
  height: 100%;
  width: 100%;
}
:deep(.el-card__body) {
  padding: 0;
  height: 100%;
}
.pointer {
  cursor: pointer;
  color: #000000;
}
.pointer:hover {
  color: #409eff; /* 鼠标悬停时的字体颜色 */
}
.el-dialog__title {
  color: #ffffff;
  font-size: 40px;
}
.carousel-title {
  font-size: 48px;
  font-weight: bold;
  color: transparent; /* 确保文本颜色透明，让背景显示出来 */
  background: linear-gradient(to right, #ecf571, #f311af, #2ec4b6);
  -webkit-background-clip: text;
  background-clip: text;
  display: inline-block;
}
@keyframes bounceDown {
  0%,
  100% {
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
    transform: translateY(-25%);
  }

  50% {
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
    transform: none;
  }
}

.bouncing-icon-container {
  display: inline-block;
  animation: bounceDown 3s infinite; /* 持续时间1秒，无限循环 */
  margin-top: 10%;
  cursor: pointer;
}

.bouncing-icon-container .el-icon {
  display: block; /* 确保图标垂直居中（如果需要的话） */
  /* 如果图标不是垂直居中的，你可能需要调整.bouncing-icon-container的样式 */
}

.title-card {
  max-width: 50%;
  min-width: 50%;
  margin: 0 auto; /* 调整顶部外边距为百分比，去除底部外边距 */
  display: block; /* 默认情况下，el-card 已经是块级元素，但这里明确指定以防万一 */
  box-sizing: border-box;
  background-color: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(8px) saturate(180%);
  border-radius: 30px;
  border: none;
  overflow: hidden; /* 防止内容溢出 */
}
.el-row {
  height: 100%; /* 尝试让 el-row 充满整个 el-card 的高度 */
  display: flex;
  align-items: center; /* 垂直居中 */
}

.left-button-col,
.right-button-col {
  display: flex;
  justify-content: center; /* 水平居中按钮（虽然在这个场景下主要是垂直居中，但水平居中也有用）*/
  align-items: center; /* 垂直居中按钮 */
}

.center-content {
  display: flex;
  flex-direction: column; /* 确保文本内容垂直排列 */
  justify-content: center; /* 文本内容在垂直方向上居中（如果需要的话，因为文本已经只有两行）*/
}
@font-face {
  font-family: "MyCustomFont";
  src: url("../../assets/font/luzhongmocaishou.ttf") format("opentype");
}
.title-p {
  font-size: 30px;
  font-family: "MyCustomFont", sans-serif;
  margin-bottom: 10px; /* 在段落之间添加垂直间距 */
}
.title-right {
  text-align: right;
  margin-bottom: 10px;
  margin-top: 0;
}

/* 隐藏图片查看器的左右切换箭头 */
:deep(.el-carousel__arrow--left,
) {
  display: none !important;
}
/* 隐藏图片查看器的左右切换箭头 */
:deep(
.el-carousel__arrow--right) {
  display: none !important;
}

.shake-icon {
  display: inline-block; /* 确保动画可以应用于此元素 */
  animation: none; /* 默认情况下不播放动画 */
}

.shake-right-icon {
  display: inline-block; /* 确保动画可以应用于此元素 */
  animation: none; /* 默认情况下不播放动画 */
}

.shake-icon:hover {
  animation: shake 1s ease-in-out 2; /* 鼠标悬停时播放动画，持续0.5秒，缓动函数为ease-in-out，重复2次 */
}

.shake-right-icon:hover {
  animation: shakeRight 1s ease-in-out 2; /* 鼠标悬停时播放动画，持续0.5秒，缓动函数为ease-in-out，重复2次 */
}
.hover-effect {
  background-color: lightblue;
  transition: transform 0.5s ease; /* 平滑的过渡效果 */
}
 .hover-effect:hover {
  transform: scale(1.1);
}

@keyframes shake {
  0% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-20px);
  }
  50% {
    transform: translateX(0);
  }
  75% {
    transform: translateX(-20px);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes shakeRight {
  0% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(20px);
  }
  50% {
    transform: translateX(0);
  }
  75% {
    transform: translateX(20px);
  }
  100% {
    transform: translateX(0);
  }
}
</style>